<template>
  <div class="s-component">
    <slot>
    </slot>
    <SModalTip ref="SModalTip"/>
    <SModalReceiveLog ref="SModalReceiveLog"/>
    <SModalAddress ref="SModalAddress"/>
  </div>
</template>

<script>
import SModalTip from "@/components/BuilderComponents/_components/ModalTip.vue";
import SModalReceiveLog from "@/components/BuilderComponents/_components/ModalReceiveLog.vue";
import SModalAddress from "@/components/BuilderComponents/_components/ModalAddress.vue";

export default {
  name: 'SActivityWrap',
  components: {
    SModalTip,
    SModalReceiveLog,
    SModalAddress
  },
  props: {
    modalBg: {
      type: Object,
      default: () => {}
    },
    modalCloseIcon: {
      type: Object,
      default: () => {}
    },
    modalTitleStyle: {
      type: String,
      default: '{}'
    },
    modalTextStyle: {
      type: String,
      default: '{}'
    },
    modalConfirmBtnStyle: {
      type: String,
      default: '{}'
    },
    modalCancelBtnStyle: {
      type: String,
      default: '{}'
    }
  },
  inject: {
    eventBus: {
      default: null
    }
  },
  provide () {
    return {
      $MainWrap: this
    }
  },
  data () {
    return {
    }
  },
  computed: {
    requestAPI() {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  mounted() {
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.init)
      // 登出操作添加
      this.eventBus.on('signOut', this.signOut)
    }
  },
  methods: {
    init() {
      console.log('登录成功初始化')
    },
    signOut() {
      console.log('退出重置')
    },
    // 打开公共弹窗
    openModalTip (options) {
      this.$refs.SModalTip.open(options)
    },
    // 打开弹窗记录
    openModalReceiveLog(options) {
      this.$refs.SModalReceiveLog.open(options)
    },
    // 打开弹窗地址
    openAddress (activityId) {
      this.$refs.SModalAddress.open(activityId)
    }
  }
}
</script>
<style lang="scss" scoped>
.s-component {
  position: relative;
  width: 1920px;
  user-select: none;
}
</style>
